<style>
  .sql-query-result-container {
    height: 250px;
    overflow-y: scroll;
    width: min-content;
  }
</style>

<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Course lesson')"></breadcrumbs>
        <div v-if="lessonProgress && lessonProgress.isDone" class="col-auto">Урок пройден</div>
        <div v-else-if="hasTasksForReview && tasksWithoutAnswers.length === 0" class="col-auto" >Ожидает проверки заданий</div>
        <div v-else-if="tasks.length > 0" class="col-auto">Выполнено заданий {{ taskProgress }} ({{ taskProgressPercent}}%)</div>
      </div>
    </base-header>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col-12">
            <div class="card p-4 bg-white">
              <playerjs-player
                v-if="hasVideo"
                ref="videoPlayer"
                :id="lessonId"
                :output-url="videoUrl"
                :poster="thumbnailUrl"
                >
              </playerjs-player>
              <mk-docs-material :html="lessonHTML"></mk-docs-material>
              <base-button
                v-if="showDoTasksButton"
                type="primary"
                style="width: 300px; margin-top:1rem"
                @click="loadTaskToDo">
                {{ $t('Do tasks') }}
              </base-button>
              <base-button
                style="width: 300px; margin-top:1rem"
                v-else-if="getNextTaskId >= 0"
                type="primary"
                @click="activateNextTask">
                {{ $t('Do tasks') }}
              </base-button>
              <!-- <base-button
                style="width: 300px; margin-top:1rem"
                v-else-if="nextLessonIsAble"
                type="primary"
                @click="toNextLesson">
                {{ $t('Go to next lesson') }}
              </base-button> -->
            </div>
          </div>
          <div v-if="todo.length > 0" class="col-12">
            <modal-lesson-task-add-answer
              v-for="(task, index) in todo"
              :key="task.id"
              :task="task"
              :id="index"
              v-model="task.show"
              @onCancel="hideModal"
              @onSend="submittedModal"
            >
            </modal-lesson-task-add-answer>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
  import {_} from 'vue-underscore';

  import Breadcrumbs from "../../Layout/Breadcrumbs.vue";
  import Spinner from 'vue-spinner-component/src/Spinner.vue';
  import MkDocsMaterial from "../../../components/MkDocs/MkDocsMaterial";

  import tasksEndpoints from "../../../api/student/tasks";

  import {getKebabToCamelDeepMap, mapListFromApi, tryExceptAwait} from "../../../utils";

  import 'okumy/static/src/js/codetasks.js';

  import {createNamespacedHelpers} from 'vuex';
  import ModalLessonTaskAddAnswer from "../../../components/Modals/ModalLessonTaskAddAnswer";
  import {LessonProgressMixin} from "../../../mixins/Lesson/LessonProgressMixin";
  import PlayerjsPlayer from "../../../components/Players/PlayerjsPlayer";
  import {PlayerjsMixin} from "../../../mixins/Video/Playerjs";

  const {mapGetters, mapActions} = createNamespacedHelpers('student/course/lesson');

  const codemirror_version = "5.58.0"

  export default {
    name: "CourseLesson",
    metaInfo() {
      return {
        title: `${this.lessonName} | ${this.$i18n.t('Lesson')}`,
        htmlAttrs: {
          lang: 'ru'
        }
      }
    },
    data() {
      return {
        orderingChanged: false,
        waiterKeyword: 'course lesson fetching',
        tasks: [],
        todo: [],
        externalStyles: [
          {
            "href": `https://cdn.jsdelivr.net/npm/codemirror@${codemirror_version}/lib/codemirror.min.css`,
            "crossorigin": "anonymous"
          },
          {
            "href": `https://cdn.jsdelivr.net/npm/codemirror@${codemirror_version}/theme/monokai.min.css`,
            "crossorigin": "anonymous"
          },
        ],
        externalScripts: [
          {
            "src": `https://cdn.jsdelivr.net/npm/codemirror@${codemirror_version}/lib/codemirror.min.js`,
            "crossorigin": "anonymous"
          },
          {
            "src": `https://cdn.jsdelivr.net/npm/codemirror@${codemirror_version}/mode/python/python.min.js`,
            "crossorigin": "anonymous"
          },
        ]
      }
    },
    mixins: [
      LessonProgressMixin,
      PlayerjsMixin
    ],
    components: {
      PlayerjsPlayer,
      ModalLessonTaskAddAnswer,
      MkDocsMaterial,
      Breadcrumbs,
      Spinner
    },
    async created() {
      this.loadExternalStatic();
      this.loadPlayerJs();
      await this.fetchData();
    },
    computed: {
      ...mapGetters({
        getLesson: 'getCurrentLesson',
        getLessonTitle: 'getLessonTitle'
      }),
      lessonId() {
        return String(this.$route.params.lessonId)
      },
      lessonName() {
        return this.getLessonTitle || ''
      },
      getNextTaskId() {
        return _.findIndex(this.todo, item => !item.show && !item.submitted)
      },
      hasTasksForReview() {
        return _.findIndex(this.tasks, item => item.needReview) !== -1
      },
      hasBlockingTodo() {
        return _.findIndex(this.todo, item => item.needReview && item.required) !== -1
      },
      nextLessonIsAble() {
        return this.getNextTaskId === -1 && !this.hasBlockingTodo
      },
      tasksWithAnswers() {
        return _.filter(this.tasks, item => item.hasAnswer)
      },
      tasksWithoutAnswers() {
        return _.filter(this.tasks, item => !item.hasAnswer)
      },
      taskProgress() {
        if (this.tasks.length > 0) {
          return `${this.tasksWithAnswers.length} / ${this.tasks.length}`
        }
        return 0
      },
      taskProgressPercent() {
        if (this.tasks.length > 0) {
          return Math.round(this.tasksWithAnswers.length / this.tasks.length * 100)
        }
        return 0
      },
      showDoTasksButton() {
        return this.tasks.length > 0 && this.tasksWithAnswers.length !== this.tasks.length
      },
      hasVideo() {
        return !_.isEmpty(this.videoUrl)
      },
      videoUrl() {
        return this.getLesson.outputUrl
      },
      thumbnailUrl() {
        return this.getLesson.thumbnailUrl
      },
      lessonHTML() {
        return this.getLesson.htmlBody
      }
    },
    watch: {
      '$route': 'fetchData',
    },
    methods: {
      isCodeTask(task) {
        return ['sql', 'code'].includes(task.taskType)
      },
      ...mapActions({
        loadLesson: 'loadLesson',
      }),
      async fetchData() {
        this.destroyVideo();
        this.$wait.start(this.waiterKeyword);
        await this.loadLesson({urlParams: this.$route.params});
        await this.loadTasks({urlParams: this.$route.params});
        this.$wait.end(this.waiterKeyword);
        await setTimeout(this.applyCodeTasks, 100);
        if (!this.lessonProgress) {
          await this.createProgress(this.currentLessonId);
          await this.loadProgress({urlParams: this.$route.params});
        }
        if (this.hasVideo) {
          // event to init player
          this.initPlayerJs(this.playerId);
        }
      },
      async loadTasks(payload) {
        this.tasks = []
        const {data, status} = await tryExceptAwait(
          tasksEndpoints.getTasks,
          [payload.urlParams]
        )
        if (status === 200) {
          this.tasks = _.filter(mapListFromApi(data), task => !this.isCodeTask(task))
        }
      },
      async loadTask(payload) {
        const {data, status} = await tryExceptAwait(
          tasksEndpoints.getTask,
          [payload.urlParams]
        )
        if (status === 200) {
          return data
        }
        return {}
      },
      destroyVideo(){
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.destroyPlayer();
        }
      },
      applyCodeTasks() {
        if ('initCodeTasks' in window) {
          // console.log('Start to initialize code tasks');
          window.initCodeTasks(
            {
              apiUrlHasTrailingSlash: true,
              baseApiUrl: `/api/courses/${this.$route.params.courseId}/lessons/${this.$route.params.lessonId}/codetasks/`,
              messages: {
                runButtonLabel: "Выполнить код",
                runError: "Ошибка выполнения кода",
                solutionButtonLabel: "Посмотреть решение",
                unhandledApiError: "Ошибка API"
              },
              requestConfig: {
                headers: new Headers({
                  Authorization: `Bearer ${localStorage.getItem("token")}`
                })
              }
            }
          )
        } else {
          console.error("no initCodeTasks in window context")
        }
      },

      async loadTaskToDo(autoShow = true) {
        let firstTaskShowed = false;
        this.todo = [];

        for (let index in this.tasksWithoutAnswers) {
          const task = this.tasksWithoutAnswers[index];
          if (!this.isCodeTask(task)) {
            // get task details from api
            const taskDetails = await this.loadTask({
              urlParams: {
                ...this.$route.params,
                taskId: task.id
              }
            })
            if (taskDetails) {
              this.todo.push({
                  ...getKebabToCamelDeepMap(taskDetails),
                  submitted: false, // will set 'true' when task answer have sent
                  show: autoShow && !firstTaskShowed
              })
              firstTaskShowed = true;
            }
          }
        }
      },
      async toNextLesson() {
        if (this.lessonProgress && !this.lessonProgress.isDone) {
          await this.makeLessonDone(this.lessonProgress.id)
        }
        await this.continueLearning()
      },
      async activateNextTask() {
        if (this.getNextTaskId !== -1) {
          this.todo[this.getNextTaskId].show = true;
        } else {
          await this.loadTasks({urlParams: this.$route.params});
          await this.loadTaskToDo()
        }
      },
      async submittedModal(currentId) {
        this.todo[currentId].show = false;
        this.todo[currentId].submitted = true;
        await this.activateNextTask()
      },
      async hideModal(currentId) {
        this.todo[currentId].show = false;
        await this.loadTasks({urlParams: this.$route.params});
        await this.loadTaskToDo(false)
      },
      loadExternalStatic() {
        _.forEach(this.externalScripts, element => {
          const scriptEl = document.createElement('script')
          scriptEl.async = true;
          scriptEl.defer = true;
          scriptEl.crossorigin = element.crossorigin;
          scriptEl.setAttribute('src', element.src)
          document.head.appendChild(scriptEl)
        })

        _.forEach(this.externalStyles, element => {
          const scriptEl = document.createElement('link')
          scriptEl.rel = 'stylesheet';
          scriptEl.crossorigin = element.crossorigin;
          scriptEl.setAttribute('href', element.href)
          document.head.appendChild(scriptEl)
        })

      }
    },
  };

</script>

<style scoped>
</style>
